module.exports = __webpack_public_path__ + "img/7.83ddd4a7.png";